import { Reveal, RevealGroup, RevealItem } from "@/components/landing/Reveal";

const CONCERNS = [
  "Your bookkeeping is months behind",
  "The balances in your accounting system do not make sense",
  "You are unsure whether income and expenses were recorded correctly",
  "Tax time creates stress because you do not trust your records",
  "You spend too much time trying to manage the books yourself",
  "You need financial information you can actually use to run your business",
];

export const PainPoints = () => (
  <section
    id="concerns"
    data-testid="painpoints-section"
    className="bg-warm-neutral py-24 md:py-32"
  >
    <div className="container-page">
      <Reveal>
        <p className="font-body text-xs sm:text-sm uppercase tracking-[0.25em] text-navy-700 mb-5">
          The everyday reality
        </p>
        <h2 className="font-heading font-semibold text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight text-navy-900 max-w-3xl">
          Do Any of These{" "}
          <span className="italic font-normal">Sound Familiar?</span>
        </h2>
      </Reveal>

      <RevealGroup
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-14"
        stagger={0.09}
      >
        {CONCERNS.map((concern, i) => (
          <RevealItem key={i}>
            <div
              data-testid={`painpoint-card-${i}`}
              className="group h-full bg-white border border-navy-900/10 rounded-lg p-8 transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-24px_rgba(15,20,40,0.35)]"
            >
              <span className="font-heading text-3xl text-[hsl(34,42%,40%)] group-hover:text-navy-900 transition-colors duration-300">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="font-body text-lg leading-relaxed text-navy-900 mt-4">
                {concern}
              </p>
            </div>
          </RevealItem>
        ))}
      </RevealGroup>

      <Reveal delay={0.1}>
        <p className="font-heading italic text-2xl sm:text-3xl text-navy-900/80 mt-14 max-w-2xl">
          You do not have to keep sorting through it alone.
        </p>
      </Reveal>
    </div>
  </section>
);

export default PainPoints;
